/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MappedSurveyResponseItem } from '../models/MappedSurveyResponseItem';
import type { MappedSurveySort } from '../models/MappedSurveySort';
import type { RecommendedCuts } from '../models/RecommendedCuts';
import type { SurveyDataCutPaymarketMapping } from '../models/SurveyDataCutPaymarketMapping';
import type { SurveyDataCutPaymarketMappingDirection } from '../models/SurveyDataCutPaymarketMappingDirection';
import type { SurveyDataCutPaymarketMappingResponseItem } from '../models/SurveyDataCutPaymarketMappingResponseItem';
import type { SurveyDataCutPerSurveyResponseItem } from '../models/SurveyDataCutPerSurveyResponseItem';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SurveyDataCutPaymarketMappingService {

    /**
     * Returns the list of survey data cuts paymarket mappings
     * @returns SurveyDataCutPaymarketMappingResponseItem Success
     * @throws ApiError
     */
    public static getSurveyDataCutPaymarketMappingList({
        paymarketId,
    }: {
        /**
         * Paymarket ID
         */
        paymarketId: number,
    }): CancelablePromise<Array<SurveyDataCutPaymarketMappingResponseItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mapping/surveyDataCut',
            query: {
                'paymarketId': paymarketId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Add  survey data cuts paymarket mappings
     * @returns SurveyDataCutPaymarketMapping Success
     * @throws ApiError
     */
    public static addSurveyDataCutPaymarketMapping({
        requestBody,
    }: {
        requestBody: {
            paymarketId: number;
            dataCutId: string;
            surveyId: string;
        },
    }): CancelablePromise<SurveyDataCutPaymarketMapping> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mapping/surveyDataCut',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of survey data cuts paymarket mappings
     * @returns MappedSurveyResponseItem Success
     * @throws ApiError
     */
    public static getMappedSurveys({
        planId,
        paymarketId,
        search,
        sort,
    }: {
        /**
         * Paymarket ID
         */
        planId: number,
        /**
         * Paymarket ID
         */
        paymarketId?: number,
        /**
         * Search
         */
        search?: string,
        /**
         * Sort object
         */
        sort?: MappedSurveySort,
    }): CancelablePromise<Array<MappedSurveyResponseItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mapping/surveyDataCut/survey',
            query: {
                'paymarketId': paymarketId,
                'planId': planId,
                'search': search,
                'sort': sort,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of recommended cuts
     * @returns RecommendedCuts Success
     * @throws ApiError
     */
    public static getRecommendedCuts({
        planId,
        sourceSurveyId,
        targetSurveyId,
    }: {
        /**
         * Plan Id
         */
        planId: number,
        /**
         * Source Survey Id
         */
        sourceSurveyId: string,
        /**
         * Target Survey Id
         */
        targetSurveyId: string,
    }): CancelablePromise<RecommendedCuts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mapping/surveyDataCut/recommendedCuts',
            query: {
                'planId': planId,
                'sourceSurveyId': sourceSurveyId,
                'targetSurveyId': targetSurveyId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Mass update cuts
     * @returns any Success
     * @throws ApiError
     */
    public static massCutsUpdate({
        requestBody,
    }: {
        requestBody: {
            planId: number;
            sourceSurveyId: string;
            targetSurveyId: string;
            dataCuts: Array<{
                sourceDataCutId: string;
                currencyId: number;
                targetDataCutId: string | null;
            }>;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mapping/surveyDataCut/mass',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Export paymarket mappings
     * @returns any Success
     * @throws ApiError
     */
    public static exportPaymarketMappings({
        planId,
        paymarketId,
    }: {
        /**
         * Plan Id
         */
        planId: number,
        /**
         * Paymarket Id
         */
        paymarketId?: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mapping/surveyDataCut/export',
            query: {
                'planId': planId,
                'paymarketId': paymarketId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Returns the list of survey data cuts paymarket mappings
     * @returns SurveyDataCutPerSurveyResponseItem Success
     * @throws ApiError
     */
    public static getSurveyDataCutPaymarketMappings({
        surveyId,
        planId,
        paymarketId,
    }: {
        /**
         * Survey ID
         */
        surveyId: string,
        /**
         * Plan ID
         */
        planId: number,
        /**
         * Paymarket ID
         */
        paymarketId?: number,
    }): CancelablePromise<Array<SurveyDataCutPerSurveyResponseItem>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mapping/surveyDataCut/survey/{surveyId}/cuts',
            path: {
                'surveyId': surveyId,
            },
            query: {
                'paymarketId': paymarketId,
                'planId': planId,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Delete survey data cuts paymarket mappings
     * @returns any Success
     * @throws ApiError
     */
    public static deleteSurveyDataCutPaymarketMapping({
        id,
    }: {
        /**
         * Survey Data Cut Paymarket Mapping ID
         */
        id: number,
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/mapping/surveyDataCut/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update survey data cuts paymarket mappings
     * @returns SurveyDataCutPaymarketMapping Success
     * @throws ApiError
     */
    public static updateSurveyDataCutPaymarketMapping({
        id,
        requestBody,
    }: {
        /**
         * Survey Data Cut Paymarket Mapping ID
         */
        id: number,
        requestBody: {
            weight?: number;
            adjustment?: number;
        },
    }): CancelablePromise<SurveyDataCutPaymarketMapping> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/mapping/surveyDataCut/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update survey data cut paymarket mapping position
     * @returns any Success
     * @throws ApiError
     */
    public static updateSurveyDataCutPaymarketMappingPosition({
        id,
        requestBody,
    }: {
        /**
         * Survey Data Cut Paymarket Mapping ID
         */
        id: number,
        requestBody: {
            direction: SurveyDataCutPaymarketMappingDirection;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/mapping/surveyDataCut/{id}/position',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

    /**
     * Update survey position
     * @returns any Success
     * @throws ApiError
     */
    public static updateSurveyPosition({
        requestBody,
    }: {
        requestBody: {
            direction: SurveyDataCutPaymarketMappingDirection;
            paymarketId: number;
            surveyId: string;
        },
    }): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mapping/surveyDataCut/position',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `The specified resource was not found`,
            },
        });
    }

}
